export default __webpack_public_path__ + "static/media/item-premium@3x.1fbd3915.png";